import { Link } from "react-router-dom";
import { latestReleases, sectionBackgroundUrl } from "@/mocks/home";
import MovieCard from "@/components/base/MovieCard";

export default function LatestRelease() {
  return (
    <section className="relative w-full py-14 md:py-20 overflow-hidden">
      <img
        src={sectionBackgroundUrl}
        alt=""
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-background-50/90"></div>

      <div className="relative z-10 w-full px-4 md:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto">
          <div className="flex items-end justify-between mb-8">
            <div>
              <span className="inline-block px-3 py-1 rounded-full text-xs font-medium bg-accent-100 text-accent-700 mb-3 whitespace-nowrap">
                最新上线
              </span>
              <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-2">
                新鲜出炉
              </h2>
              <p className="text-sm text-foreground-500">刚上线的新作品，快来尝鲜</p>
            </div>
            <Link
              to="/category/movie"
              className="hidden sm:flex items-center gap-1 text-sm text-accent-600 hover:text-accent-700 transition-colors whitespace-nowrap font-medium"
            >
              查看全部
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>

          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-3 lg:grid-cols-6 gap-4 md:gap-5" data-product-shop="">
            {latestReleases.map((item) => (
              <MovieCard key={item.id} {...item} />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}